import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FlaskConical, LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth-context";
import { supabase } from "@/integrations/supabase/client";

export const TEST_MEMBER_EMAIL = "Filippos.marras@elonljudbild.se";

export function TestModeBanner() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const isTest = user?.email?.toLowerCase() === TEST_MEMBER_EMAIL;

  useEffect(() => {
    if (isTest) document.body.dataset.testMode = "1";
    else delete document.body.dataset.testMode;
  }, [isTest]);

  if (!isTest) return null;

  async function exitTestMode() {
    setBusy(true);
    await supabase.auth.signOut();
    await signOut();
    navigate("/af-portal", { replace: true });
  }

  return (
    <div className="w-full bg-[var(--color-gold)] text-[var(--color-ink)] border-b border-[var(--color-ink)]/20 sticky top-0 z-[60]">
      <div className="max-w-6xl mx-auto px-4 py-2 flex items-center justify-between gap-3 text-sm">
        <div className="flex items-center gap-2 font-display font-semibold">
          <FlaskConical size={16} />
          <span>Testläge — du är inloggad som <strong>Test Testsson</strong> (delat demokonto).</span>
        </div>
        <button
          type="button"
          onClick={exitTestMode}
          disabled={busy}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[var(--color-ink)] text-white text-xs font-display font-semibold hover:opacity-90 transition disabled:opacity-60"
        >
          <LogOut size={13} /> {busy ? "Avslutar…" : "Återgå till ÅF-portalen"}
        </button>
      </div>
    </div>
  );
}
